/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import "./Payment.css";
import PaymentCom from "./PaymentCom";

class Success extends PaymentCom {

    async componentDidMount() {
        await this.loadSession(this.props.params.sid);
        const data = {
            solusekPayment: {
                sid: this.props.params.sid
            }
        };
        window.parent.postMessage(data,"*");
    }

    render() {
        return <div className="container py-3">
            <h1>Payment Successful</h1>
            <p>Completing order...</p>
        </div>
    }
}

export default withParamsAndNavigate(Success);